import { Pipe, PipeTransform } from '@angular/core';
import { PolynomialForms } from '@models/stable-balance/polynomial-forms';

@Pipe({ name: 'numToPoly' })
export class NumberPolyPipe implements PipeTransform {
  transform(formId: number, ...args: any[]): any {
    return PolynomialForms[formId];
  }
}
